import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import FormAddEditRole from "../../components/roles/FormAddEditRole";
import LoadingPage from "../../components/global/LoadingPage";
import { useGetRoleById } from "../../hooks/roles/useGetRoleById";

const EditRole = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const { role, isLoading, error } = useGetRoleById(id);

    if (isLoading) return <LoadingPage />;
    if (error || !role) return null;

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditRole
                isEdit={true}
                currentData={role}
                onSubmitSuccess={() => navigate("/settings/roles")}
            />
        </WrapperSection>
    );
};

export default EditRole;
